import { lazy } from 'react';

export const LazyCancelSubscriptionPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--cancel-subscription-page" */ './cancel-subscription-page'
    ),
);
